import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-y-8 w-1/2 mx-auto border-x border-slate-50 border-indigo-500" };
const _hoisted_2 = { class: "flex flex-nowrap items-center gap-2" };
const _hoisted_3 = { class: "grow text-xl text-3xl font-light" };
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-file-edit",
    style: { "font-size": "1.2rem" }
}, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-trash",
    style: { "font-size": "1.2rem" }
}, null, -1);
import { useConfirm } from 'primevue/useconfirm';
import { useDialog } from 'primevue/usedialog';
import Button from 'primevue/button';
import Column from 'primevue/column';
import ConfirmPopup from 'primevue/confirmpopup';
import DataTable from 'primevue/datatable';
import DynamicDialog from 'primevue/dynamicdialog';
import FileUpload from 'primevue/fileupload';
import ProgressSpinner from 'primevue/progressspinner';
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import DigitalVendorEndpointForm from './DigitalVendorEndpointForm.vue';
import { useDateFns, useDigitalVendorEndpoint, useToastNotifications } from '@apparatix/composables';
import { DigitalVendorEndpointStore as store } from '../stores/DigitalVendorEndpointStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DigitalVendorAdmin',
    props: {
        sspList: {},
        endpointTypes: {}
    },
    setup(__props) {
        const props = __props;
        store.setVendors(props.sspList);
        store.setAvailableEndpointTypes(props.endpointTypes);
        const { deleteEndpoint, uploadFile } = useDigitalVendorEndpoint();
        const { formatDate, formatDistance } = useDateFns();
        const confirmDelete = useConfirm();
        const editDialog = useDialog();
        const { showSuccess, showError } = useToastNotifications();
        const showNewOrEditModal = (vendor, endpoint = null) => {
            if (!vendor)
                return;
            if (!endpoint) {
                store.setActiveEndpoint(store.getEmptyEndpointModel(vendor.id));
            }
            else {
                store.setActiveEndpoint(endpoint);
            }
            editDialog.open(DigitalVendorEndpointForm, {
                props: {
                    header: endpoint === null ? 'Create new endpoint' : 'Edit endpoint',
                    style: { width: '33vw' },
                    modal: true,
                    blockScroll: true,
                    position: 'top',
                },
            });
        };
        const getTypeTagColor = (type) => {
            switch (type.toLowerCase()) {
                case 'authorization':
                    return '';
                case 'ads':
                    return 'success';
                case 'inventory':
                    return 'info';
                case 'reporting':
                    return 'warning';
                default:
                    return 'info';
            }
        };
        const canDelete = (type) => type.toLowerCase() === 'reporting';
        const onDeleteClick = (event, endpoint) => {
            confirmDelete.require({
                target: event.currentTarget,
                message: 'Are you sure you want to delete this endpoint? This cannot be undone',
                header: 'Confirm delete',
                accept: () => handleDelete(endpoint),
                position: 'bottomleft',
                icon: 'pi pi-exclamation-triangle',
            });
        };
        const handleDelete = async (endpoint) => {
            endpoint.isLoading = true;
            const result = await deleteEndpoint(endpoint.id);
            if (result) {
                store.removeEndpointFromList(endpoint);
            }
            else {
                endpoint.isLoading = false;
                showError('Error deleting endpoint');
            }
        };
        const onUpload = async (vendorId, event) => {
            const result = await uploadFile(vendorId, event.files[0]);
            if (result) {
                showSuccess('File successfully uploaded');
            }
            else {
                showError('Error uploading file');
            }
        };
        const getDeleteButtonTooltipText = (type) => {
            if (type.toLowerCase() === 'reporting')
                return 'Endpoints of type reporting cannot be deleted';
            return 'Delete this endpoint';
        };
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).vendors, (vendor) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: vendor.display_name,
                            class: "table"
                        }, [
                            _createVNode(_unref(DataTable), {
                                "striped-rows": "",
                                value: vendor.digital_vendor_endpoints,
                                class: "p-datatable-sm",
                                pt: {
                                    header: () => ({
                                        style: {
                                            'background-color': '#E8EAFF'
                                        }
                                    }),
                                    table: () => ({
                                        style: {
                                            'table-layout': 'fixed',
                                        },
                                    }),
                                }
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("h1", _hoisted_3, _toDisplayString(vendor.display_name), 1),
                                        _withDirectives(_createVNode(_unref(FileUpload), {
                                            style: { "font-size": "11px" },
                                            name: "file",
                                            url: "/digital-vendor/admin/import",
                                            mode: "basic",
                                            accept: ".csv",
                                            "choose-label": "Backfill",
                                            auto: true,
                                            "custom-upload": "",
                                            onUploader: ($event) => (onUpload(vendor.id, $event))
                                        }, null, 8, ["onUploader"]), [
                                            [
                                                _directive_tooltip,
                                                'Upload backfill',
                                                void 0,
                                                { left: true }
                                            ]
                                        ]),
                                        _withDirectives(_createVNode(_unref(Button), {
                                            label: "Add",
                                            icon: "pi pi-plus",
                                            size: "small",
                                            onClick: ($event) => (showNewOrEditModal(vendor))
                                        }, null, 8, ["onClick"]), [
                                            [
                                                _directive_tooltip,
                                                `Add a new Digital Vendor Endpoint to ${vendor.display_name}`,
                                                void 0,
                                                { left: true }
                                            ]
                                        ])
                                    ])
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), {
                                        header: "Type",
                                        style: { "width": "100px" }
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(_unref(Tag), {
                                                severity: getTypeTagColor(slotProps.data.type),
                                                value: slotProps.data.type
                                            }, null, 8, ["severity", "value"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Base URL",
                                        style: { "width": "100%" }
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("a", {
                                                href: slotProps.data.base_url,
                                                target: "_new",
                                                class: "hover:underline"
                                            }, _toDisplayString(slotProps.data.base_url), 9, _hoisted_4)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Created",
                                        style: { "width": "150px" }
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.created_at)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Updated",
                                        style: { "width": "150px" }
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDistance)(slotProps.data.updated_at)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), { style: { "width": "80px" } }, {
                                        body: _withCtx((slotProps) => [
                                            _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                                                size: "small",
                                                severity: "info",
                                                rounded: "",
                                                outlined: "",
                                                onClick: ($event) => (showNewOrEditModal(vendor, slotProps.data))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_5
                                                ]),
                                                _: 2
                                            }, 1032, ["onClick"])), [
                                                [
                                                    _directive_tooltip,
                                                    'Edit this endpoint',
                                                    void 0,
                                                    { left: true }
                                                ]
                                            ])
                                        ]),
                                        _: 2
                                    }, 1024),
                                    _createVNode(_unref(Column), { style: { "width": "80px" } }, {
                                        body: _withCtx((slotProps) => [
                                            _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                                (!slotProps.data.isLoading)
                                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                                        key: 0,
                                                        size: "small",
                                                        severity: "danger",
                                                        disabled: canDelete(slotProps.data.type),
                                                        rounded: "",
                                                        outlined: "",
                                                        onClick: ($event) => (onDeleteClick($event, slotProps.data))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_6
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["disabled", "onClick"]))
                                                    : (_openBlock(), _createBlock(_unref(ProgressSpinner), {
                                                        key: 1,
                                                        style: { "width": "40px", "height": "40px" },
                                                        "stroke-width": "2",
                                                        "animation-duration": ".5s"
                                                    }))
                                            ])), [
                                                [
                                                    _directive_tooltip,
                                                    getDeleteButtonTooltipText(slotProps.data.type),
                                                    void 0,
                                                    { left: true }
                                                ]
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 2
                            }, 1032, ["value"])
                        ]));
                    }), 128))
                ]),
                _createVNode(_unref(DynamicDialog)),
                _createVNode(_unref(ConfirmPopup)),
                _createVNode(_unref(Toast))
            ], 64));
        };
    }
});
